import { superToggle } from "./helpers/super-toggle";
import { bodyLockToggle } from "./helpers/body-lock-toggle";

window.addEventListener('load', () => {
    const faqPanels = document.querySelectorAll('section.faq-panel');
    const feedbackFormModal = document.getElementById('feedback-form-modal');
    let clearedStyles = false;

    if (feedbackFormModal && faqPanels.length) {
        const contactFormCross = feedbackFormModal.querySelector('#feedback-form-modal-cross');
        const contactFormBackdrop = feedbackFormModal.querySelector('#feedback-form-modal-backdrop');

        // Function to toggle modal visibility
        const toggleModalVisibility = () => {
            superToggle(feedbackFormModal, ['opacity-0', 'pointer-events-none', 'select-none']);
            if (contactFormCross) {
                superToggle(contactFormCross, ['pointer-events-auto', 'cursor-pointer']);
            }
            bodyLockToggle();
            feedbackFormModal.querySelector('.freeform-form-success')?.remove()
            feedbackFormModal.querySelector('#form-input-message').value = '';
        };

        // Close modal on cross click
        if (contactFormCross) {
            contactFormCross.addEventListener('click', toggleModalVisibility);
        }

        // Close modal on backdrop click
        if (contactFormBackdrop) {
            contactFormBackdrop.addEventListener('click', toggleModalVisibility);
        }

        // Iterate through each faq-panel
        faqPanels.forEach(faqPanel => {
            faqPanel.addEventListener('click', event => {
                const target = event.target;

                // Handle negative review button click
                if (target.matches('button[data-faq-review="negative"]')) {
                    const neutralDiv = target.closest('div[data-state="neutral"]');

                    if (neutralDiv) {
                        neutralDiv.setAttribute('data-state', 'negative');

                        // Revert to neutral after 5 seconds
                        setTimeout(() => {
                            neutralDiv.setAttribute('data-state', 'neutral');
                        }, 5000);
                    }
                }


                if (target.matches('button[data-prompt-response]')) {
                    // Populate the modal's span[data-faq-question] with button's data-faq-question value
                    const faqQuestion = target.getAttribute('data-faq-question');
                    const modalFaqQuestionSpan = feedbackFormModal.querySelector('span[data-faq-question]');
                    const feedbackQuestionFormInputs = feedbackFormModal.querySelectorAll('input[name="feedbackForFaq"]');
                    if (modalFaqQuestionSpan && faqQuestion) {
                        modalFaqQuestionSpan.textContent = faqQuestion;
                        for (const feedbackQuestionFormInput of feedbackQuestionFormInputs) {
                            feedbackQuestionFormInput.value = faqQuestion;
                        }
                    }

                    // Show the modal
                    if (!clearedStyles) {
                        feedbackFormModal.removeAttribute('style');
                        clearedStyles = true;
                        setTimeout(() => toggleModalVisibility(), 50);
                    } else {
                        toggleModalVisibility();
                    }
                }

                // Handle positive review button click
                if (target.matches('button[data-faq-review="positive"]')) {
                    const neutralDiv = target.closest('div[data-state]');

                    if (neutralDiv) {
                        const heartTemplate = document.querySelector('template.heart-icon');

                        if (heartTemplate) {
                            let heartCount = 5; // Number of hearts to spawn

                            const createHeart = () => {
                                const clonedHeart = heartTemplate.content.cloneNode(true).querySelector('svg');
                                if (!clonedHeart) return;

                                const randomSize = Math.random() * (1.5 - 0.75) + 0.75; // Random size between 0.75rem and 1.5rem
                                clonedHeart.style.width = `${randomSize}rem`;
                                clonedHeart.style.height = `${randomSize}rem`;

                                // Convert randomSize from rem to pixels (assuming 1rem = 16px)
                                const sizeInPixels = randomSize * 16;

                                // Random position above the neutralDiv
                                const randomX = Math.random() * 100;
                                const randomY = -(sizeInPixels + Math.random() * 10); // 0 to 10px above the height

                                clonedHeart.style.position = 'absolute';
                                clonedHeart.style.left = `${randomX}%`;
                                clonedHeart.style.top = `${randomY}px`;
                                neutralDiv.appendChild(clonedHeart);

                                // Remove after animation
                                setTimeout(() => {
                                    clonedHeart.remove();
                                }, 1500);
                            };

                            let heartInterval = setInterval(() => {
                                if (heartCount > 0) {
                                    createHeart();
                                    heartCount--;
                                } else {
                                    clearInterval(heartInterval);
                                }
                            }, 250); // Create a heart every 0.25 seconds
                        }
                    }
                }
            });
        });
    }

});
